module.exports = __webpack_public_path__ + "static/media/lucastswick-logo-1.07d39cef.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logos/lucastswick-logo-1.jpg
// module id = 4379
// module chunks = 14